import Contact from "components/Contactanos/Contact";
import StepperForm from "components/Contactanos/StepperForm";
import HeroContact from "components/hero/HeroContact";
import React from "react";

const NumberLink = ({ number, contact }) => {
  return (
    <div className="w-full flex gap-3 items-center">
      <span className="bg-yellow-1 p-1 rounded-lg text-primario w-max">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <path d="M5 4h4l2 5l-2.5 1.5a11 11 0 0 0 5 5l1.5 -2.5l5 2v4a2 2 0 0 1 -2 2a16 16 0 0 1 -15 -15a2 2 0 0 1 2 -2" />
        </svg>
      </span>
      <div className="flex flex-col text-sm">
        <h4 className="font-bold text-yellow-1">{contact}</h4>
        <a href={`tel:${number}`}>{number}</a>
      </div>
    </div>
  );
};

const CardMap = () => {
  return (
    <div className="w-full sm:w-1/2 lg:w-full flex flex-col gap-3 p-4 sm:p-5 outline outline-primario shadow-custom-first rounded-lg items-center">
      <img
        src="https://brightonenglishcenter.edu.co/img/Instalaciones.jpg"
        alt="Instalaciones Brighton"
        className="w-full h-72 sm:h-72 lg:h-80 object-cover rounded-lg object-top"
      />

      <a
        href="https://maps.app.goo.gl/KkxmV46hZVmjdcva7"
        target="_blank"
        rel="noopener noreferrer"
        className="capitalize font-bold flex items-center gap-1 text-primario text-sm sm:text-base"
      >
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            class="icon icon-tabler icons-tabler-outline icon-tabler-external-link"
          >
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" />
            <path d="M11 13l9 -9" />
            <path d="M15 4h5v5" />
          </svg>
        </span>
        Ver en google maps
      </a>
    </div>
  );
};

function Contacto() {
  return (
    <>
      <HeroContact />

      <section className="min-h-screen flex flex-col lg:flex-row gap-8 lg:gap-10 px-4 sm:px-6 lg:px-10 xl:px-20 py-12 sm:py-16 lg:py-20">
        {/* LEFT */}
        <div className="flex flex-col w-full lg:w-2/3 gap-6 sm:gap-8">
          <StepperForm />

          {/* BENEFICIOS */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex gap-3 items-center text-primario bg-yellow-1 p-3 sm:p-4 rounded-lg">
              <span className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-rosette-discount-check"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M5 7.2a2.2 2.2 0 0 1 2.2 -2.2h1a2.2 2.2 0 0 0 1.55 -.64l.7 -.7a2.2 2.2 0 0 1 3.12 0l.7 .7c.412 .41 .97 .64 1.55 .64h1a2.2 2.2 0 0 1 2.2 2.2v1c0 .58 .23 1.138 .64 1.55l.7 .7a2.2 2.2 0 0 1 0 3.12l-.7 .7a2.2 2.2 0 0 0 -.64 1.55v1a2.2 2.2 0 0 1 -2.2 2.2h-1a2.2 2.2 0 0 0 -1.55 .64l-.7 .7a2.2 2.2 0 0 1 -3.12 0l-.7 -.7a2.2 2.2 0 0 0 -1.55 -.64h-1a2.2 2.2 0 0 1 -2.2 -2.2v-1a2.2 2.2 0 0 0 -.64 -1.55l-.7 -.7a2.2 2.2 0 0 1 0 -3.12l.7 -.7a2.2 2.2 0 0 0 .64 -1.55v-1" />
                  <path d="M9 12l2 2l4 -4" />
                </svg>
              </span>
              <div>
                <h3 className="font-bold text-sm sm:text-base">
                  Certificación Oficial
                </h3>
                <p className="text-xs sm:text-sm">
                  Avala tus conocimientos globalmente.
                </p>
              </div>
            </div>

            <div className="flex gap-3 items-center text-primario bg-gray-200 p-3 sm:p-4 rounded-lg">
              <span className="w-10 h-10 bg-white/70 rounded-full flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="30"
                  height="30"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-clock"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                  <path d="M12 7v5l3 3" />
                </svg>
              </span>
              <div>
                <h3 className="font-bold text-sm sm:text-base">
                  Horarios de Atención
                </h3>
                <p className="text-xs sm:text-sm">
                  Lunes a Viernes: 8:00 am - 8:30 pm <br />
                  Sábados: 8:00 am - 1:00 pm  
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT */}
        <div className="flex flex-col sm:flex-row lg:flex-col w-full lg:w-1/3 gap-6 sm:gap-8">
          {/* CONTACT INFO */}
          <div className="flex flex-col w-full sm:w-1/2 lg:w-full bg-primario rounded-lg p-4 sm:p-5 text-white gap-4">
            <h3 className="text-lg sm:text-xl font-bold pb-3 border-b border-gray-500">
              Información de Contacto
            </h3>

            <div className="grid grid-cols-1 xl:grid-cols-2 gap-3">
              <NumberLink number="(602) 721 07 51" contact="Oficina" />
              <NumberLink number="+57 318 3163984" contact="Academico" />
              <NumberLink number="+57 318 5289302" contact="Examenes" />
              <NumberLink number="+57 316 8664459" contact="Ventas" />
            </div>

            {/* WHATSAPP */}
            <div className="flex gap-3 items-center">
              <span className="bg-green-600 p-1 rounded-lg text-white">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-brand-whatsapp"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 21l1.65 -3.8a9 9 0 1 1 3.4 2.9l-5.05 .9" />
                  <path d="M9 10a.5 .5 0 0 0 1 0v-1a.5 .5 0 0 0 -1 0v1a5 5 0 0 0 5 5h1a.5 .5 0 0 0 0 -1h-1a.5 .5 0 0 0 0 1" />
                </svg>
              </span>
              <div className="text-sm">
                <h4 className="font-bold text-yellow-1">WhatsApp</h4>
                <a href="">Chatea con un asesor</a>
              </div>
            </div>

            {/* DIRECCION */}
            <div className="flex gap-3 items-center">
              <span className="bg-white/20 p-1 rounded-lg text-yellow-1 flex items-center justify-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="25"
                  height="25"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  class="icon icon-tabler icons-tabler-filled icon-tabler-map-pin"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M18.364 4.636a9 9 0 0 1 .203 12.519l-.203 .21l-4.243 4.242a3 3 0 0 1 -4.097 .135l-.144 -.135l-4.244 -4.243a9 9 0 0 1 12.728 -12.728zm-6.364 3.364a3 3 0 1 0 0 6a3 3 0 0 0 0 -6" />
                </svg>
              </span>
              <div className="text-sm">
                <h4 className="font-bold text-yellow-1">Visítanos</h4>
                <p>Carrera 38 # 19-26, Barrio Palermo, Pasto, Nariño.</p>
              </div>
            </div>
          </div>

          <CardMap />
        </div>
      </section>
    </>
  );
}

export default Contacto;
